module.exports = __webpack_public_path__ + "img/sn5.efdd8144.jpeg";